<template>
  <div class="bridge-signing-table">
    <v-card-title class="toolbar primary white--text">
      <div>
        <span class="headline">
          <h1 class="headline ml-2">
            <v-icon dark>description</v-icon>
            Bridge Signing Management
          </h1>
        </span>
      </div>
      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Filter results"
        single-line
        flat
        dark
        color="primary"
        solo-inverted
        hide-details
      />
      <v-tooltip
        top
        dark
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="warning"
            fab
            dark
            absolute
            bottom
            right
            @click.stop="toggleCreating"
            v-on="on"
          >
            <v-icon>note_add</v-icon>
          </v-btn>
        </template>
        <span>Create new Bridge Signing</span>
      </v-tooltip>
    </v-card-title>

    <!-- DATA TABLE -->
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :pagination.sync="pagination"
      :loading="isLoading"
      loading-text="Loading..."
      disable-initial-sort
    >
      <!-- SIGNINGS DATA TABLE ROW START -->
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td class="">
            {{ props.item.detail_id }}
          </td>

          <td class="">
            {{ props.item.id }}
          </td>

          <td>
            {{ props.item.user_id }}
          </td>

          <td class="text-xs">
            <v-chip outline>
              {{ props.item.investtype }}
            </v-chip>
          </td>

          <td class="text-xs">
            {{ props.item.pieces }}
          </td>

          <td class="text-xs">
            {{ props.item.paid_at }}
          </td>

          <td class="text-xs">
            {{ props.item.contract_accepted_at }}
          </td>

          <td class="text-xs">
            {{ props.item.created_at }}
          </td>

          <td class="text-xs">
            {{ props.item.updated_at }}
          </td>

          <td class="text-xs">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  flat
                  icon
                  color="primary"
                  v-on="on"
                  @click.stop="() => onEditSigning(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      <!-- SIGNINGS DATA TABLE ROW END -->
    </v-data-table>

    <!-- CREATE NEW IDENT DIALOG -->
    <CreateBridgeSigningDialog
      :is-open="isCreating"
      :toggle-open="toggleCreating"
    />
    <EditBridgeSigningDialog
      :is-open="isEditing"
      :bridge-signing="currEditSigning"
      :toggle-open="toggleEditing"
    />
  </div>
</template>

<script>
import CreateBridgeSigningDialog from './dialog/CreateBridgeSigning';
import EditBridgeSigningDialog from './dialog/EditBridgeSigning';

export default {
  name: 'BridgeSigningTable',
  components: {
    CreateBridgeSigningDialog,
    EditBridgeSigningDialog,
  },
  data() {
    return {
      isLoading: false,
      isCreating: false,
      isEditing: false,
      currEditSigning: {},
      pagination: {},
      search: '',
      headers: [
        { text: 'Detail id', value: 'detail_id' },
        { text: 'Contract id', value: 'id' },
        { text: 'User id', value: 'user_id' },

        { text: 'Investment type', value: 'investtype' },
        { text: 'Pieces', value: 'pieces' },
        { text: 'Paid at', value: 'paid_at' },
        { text: 'Accepted at', value: 'contract_accepted_at' },

        { text: 'Created at', value: 'created_at' },
        { text: 'Updated at', value: 'updated_at' },

        { text: 'Actions', value: null, sortable: false },
      ],
    };
  },
  computed: {
    signings() {
      return this.$store.state.bridgeSigningStore.signings;
    },
    filteredItems() {
      const { search } = this;

      return search.length < 1 ?
        this.signings :
        this.signings.filter((item) => {
          let found = false;
          Object.keys(item)
            .map((key) => {
              if (item[key] && String(item[key]).indexOf(search) > -1) {
                found = true;
              }

              return key;
            });

          return found;
        });
    },
  },

  watch: {
    pagination: {
      handler() {
      },
      deep: true,
    },
  },

  mounted() {
    this.getSignings();
  },

  methods: {
    getSignings() {
      this.isLoading = true;
      this.$store.dispatch('fetchBridgeSignings')
        .finally(() => {
          this.isLoading = false;
        });
    },
    toggleCreating() {
      this.isCreating = !this.isCreating;
    },
    toggleEditing() {
      this.isEditing = !this.isEditing;
    },
    onEditSigning(currEditSigning) {
      this.currEditSigning = currEditSigning;
      this.toggleEditing();
    },
  },
};
</script>
<style lang="scss">
.bridge-signing-table {
  > .toolbar {
    position: relative;
    padding: 24px 24px 32px 24px;
    margin-bottom: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bridgeSigning/BridgeSigningTable.vue